import { __assign, __awaiter, __generator, __read, __spread } from "tslib";
import React, { useState, memo, useEffect } from 'react';
import { app } from '@ekuaibao/whispered';
import styles from './filter.module.less';
import { Select } from '@hose/eui';
import { DropdownRender, MaxTagPlaceholder } from './columnOthers';
import DepartmentTree from './DepartmentTree';
import DepartmentList from './DepartmentList';
import { setDepartmentCache, getDepartmentsFromCache } from './FilterCache';
import { debounce } from 'lodash';
import { getDisplayName } from "../utilFn";
import { NameCell } from '../name-cell';
var getPopupContainer = function (node) { return node.parentNode; };
export var DepartmentFilter = memo(function (_a) {
    var value = _a.value, onChange = _a.onChange, onOk = _a.onOk, onReset = _a.onReset, scenesType = _a.scenesType;
    var _b = __read(useState(value !== null && value !== void 0 ? value : []), 2), checkedKeys = _b[0], setCheckedKeys = _b[1];
    var _c = __read(useState({}), 2), departmentPathMap = _c[0], setDepartmentPathMap = _c[1];
    var _d = __read(useState([]), 2), departmentTree = _d[0], setDepartmentTree = _d[1];
    var _e = __read(useState({}), 2), departmentMap = _e[0], setDepartmentMap = _e[1];
    var _f = __read(useState(true), 2), isInit = _f[0], setIsInit = _f[1];
    var _g = __read(useState('select'), 2), valueChangeFrom = _g[0], setValueChangeFrom = _g[1];
    var _h = __read(useState([]), 2), selectList = _h[0], setSelectList = _h[1];
    var _j = __read(useState(''), 2), searchStr = _j[0], setSearchStr = _j[1];
    useEffect(function () {
        initData();
        getData();
    }, []);
    var initData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var departments;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsInit(true);
                    return [4, getDepartmentsFromCache(value)];
                case 1:
                    departments = _a.sent();
                    setSelectList(formatDepartmentData(departments));
                    return [2];
            }
        });
    }); };
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, departmentData, departmentTree, departmentPath, pathMap, departmentMapData;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4, Promise.all([app.dataLoader('@common.department').load()])];
                case 1:
                    _a = __read.apply(void 0, [_f.sent(), 1]), departmentData = _a[0];
                    departmentTree = (_b = departmentData === null || departmentData === void 0 ? void 0 : departmentData.data) !== null && _b !== void 0 ? _b : [];
                    departmentPath = (_c = departmentData === null || departmentData === void 0 ? void 0 : departmentData.noRootPathMap) !== null && _c !== void 0 ? _c : {};
                    pathMap = i18n.currentLocale === 'zh-CN' ? departmentPath : (_d = departmentData === null || departmentData === void 0 ? void 0 : departmentData.noRootEnPathMap) !== null && _d !== void 0 ? _d : {};
                    departmentMapData = (_e = departmentData === null || departmentData === void 0 ? void 0 : departmentData.mapData) !== null && _e !== void 0 ? _e : {};
                    setDepartmentMap(departmentMapData);
                    setDepartmentTree(departmentTree);
                    setDepartmentPathMap(pathMap);
                    return [2];
            }
        });
    }); };
    var handleChange = function (from, newValue, department) { return __awaiter(void 0, void 0, void 0, function () {
        var listIds, departments;
        return __generator(this, function (_a) {
            setIsInit(false);
            setValueChangeFrom(from);
            listIds = __spread(selectList).map(function (item) { return item.id; });
            if (!listIds.includes(department.id)) {
                departments = __spread(selectList, [department]);
                setSelectList(formatDepartmentData(departments));
                setDepartmentCache(departments);
            }
            setCheckedKeys(newValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
            return [2];
        });
    }); };
    var handleClear = function () {
        setCheckedKeys([]);
        setSearchStr('');
        onChange === null || onChange === void 0 ? void 0 : onChange([]);
    };
    var handleConfirm = function () {
        onOk === null || onOk === void 0 ? void 0 : onOk();
    };
    var handleReset = function () {
        setCheckedKeys([]);
        setSearchStr('');
        onReset === null || onReset === void 0 ? void 0 : onReset();
    };
    var handleSearch = debounce(function (searchValue) {
        setValueChangeFrom('select');
        setIsInit(false);
        setSearchStr(searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim());
    }, 500);
    return (React.createElement("div", { className: styles['filter-content-wrapper'] },
        React.createElement(Select, { getPopupContainer: getPopupContainer, placeholder: i18n.get('请选择要筛选的部门'), value: checkedKeys, dropdownRender: function (menu) { return React.createElement("div", { style: { display: 'none' } }, menu); }, mode: "multiple", fieldNames: { label: 'name', value: 'id' }, maxTagPlaceholder: function (omittedValues) { return React.createElement(MaxTagPlaceholder, { omittedValues: omittedValues }); }, onChange: function (value, option) { return handleChange('select', value, option); }, onSearch: handleSearch, onClear: handleClear, optionFilterProp: "children", style: { width: '100%' }, autoFocus: true, allowClear: true, showSearch: true, showArrow: true, virtual: true, open: true, maxTagCount: 2, options: selectList }),
        React.createElement(DropdownRender, { className: styles['filter-dropdown-render'], originNode: React.createElement(DepartmentContent, { valueChangeFrom: valueChangeFrom, departmentMap: departmentMap, searchKey: searchStr, value: checkedKeys, isInit: isInit, departmentTree: departmentTree, initList: selectList, departmentPathMap: departmentPathMap, onChange: handleChange, scenesType: scenesType }), onConfirm: handleConfirm, onReset: handleReset })));
});
export var DepartmentContent = function (_a) {
    var valueChangeFrom = _a.valueChangeFrom, value = _a.value, searchKey = _a.searchKey, departmentTree = _a.departmentTree, departmentPathMap = _a.departmentPathMap, departmentMap = _a.departmentMap, initList = _a.initList, isInit = _a.isInit, onChange = _a.onChange, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.scenesType, scenesType = _c === void 0 ? '' : _c;
    var _d = __read(useState(false), 2), isTreeView = _d[0], setIsTreeView = _d[1];
    useEffect(function () {
        setIsTreeView(((!searchKey && !value.length) || valueChangeFrom === 'tree') && scenesType !== 'MyBill');
    }, [searchKey, valueChangeFrom, value]);
    var treeDataChange = function (from, value, itemKey) {
        var department = departmentMap[itemKey];
        onChange(from, value, department);
    };
    return isTreeView ? (React.createElement(DepartmentTree, { value: value, treeData: departmentTree, onChange: treeDataChange, className: className })) : (React.createElement(DepartmentList, { value: value, isInit: isInit, initList: initList, searchStr: searchKey, departmentPathMap: departmentPathMap, onChange: onChange }));
};
var formatDepartmentData = function (departments) {
    return departments.map(function (department) {
        return __assign(__assign({}, department), { id: department.id, name: window.isInWeComISV ? React.createElement(NameCell, { type: "department", id: department.id, name: getDisplayName(department) }) : getDisplayName(department) });
    });
};
export default DepartmentFilter;
